<p class="center">Leader boards coming soon...</p>
<button mat-fab class="fab" (click)="newGame()">
    <mat-icon>add</mat-icon>
</button>
